import { useContext, useLayoutEffect } from 'react';
import { WindmillContext } from '@windmill/react-ui';

const THEME_COLORS = {
  dark: '#09090b',
  light: '#ffffff',
};

function ThemeClassSync() {
  const { mode } = useContext(WindmillContext);

  useLayoutEffect(() => {
    const isDark = mode === 'dark';
    const root = document.documentElement;
    const themeColor = document.querySelector('meta[name="theme-color"]');

    root.classList.toggle('dark', isDark);
    root.classList.toggle('theme-dark', isDark);
    root.classList.toggle('theme-light', !isDark);
    root.style.colorScheme = isDark ? 'dark' : 'light';

    if (themeColor) {
      themeColor.setAttribute(
        'content',
        isDark ? THEME_COLORS.dark : THEME_COLORS.light
      );
    }
  }, [mode]);

  return null;
}

export default ThemeClassSync;
